import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { SelectTreeResponse } from "./types";

export const selectTree = async (treeId: string) =>
    await fciFetch<SelectTreeResponse>(`/api/person-picker/setselectedtree/${treeId}`, {
        method: "GET",
        fci: {
            // Switches the active tree in the person-picker suggestions flow
            // If it fails, the user can still fill in the form manually
            errorType: FCI_ERROR.Convenience,
            errorInfo: "selectTree",
        },
    });
